var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import { useEntityMutation } from './use-entity-mutation';
export var COMMUNITY_REQUEST_FIELDS = [{
  "label": "Name",
  "description": "",
  "ownDescription": "",
  "name": "name",
  "type": "text",
  "formFieldType": "text",
  "required": true,
  "entityTypeName": "",
  "entityTypeNamePlural": ""
}, {
  "label": "Title",
  "description": "",
  "ownDescription": "",
  "name": "title",
  "type": "text",
  "formFieldType": "text",
  "required": false,
  "entityTypeName": "",
  "entityTypeNamePlural": ""
}, {
  "label": "Description",
  "description": "",
  "ownDescription": "",
  "name": "description",
  "type": "longText",
  "formFieldType": "longText",
  "required": false,
  "entityTypeName": "",
  "entityTypeNamePlural": ""
}, {
  "label": "Is Completed",
  "description": "Is this Comment complete?",
  "ownDescription": "",
  "name": "isCompleted",
  "type": "boolean",
  "formFieldType": "boolean",
  "required": false,
  "entityTypeName": "",
  "entityTypeNamePlural": ""
}];
export var useCommunityRequestActions = function (_a) {
  var onSuccessSubmit = _a.onSuccessSubmit,
    refetchRequests = _a.refetchRequests;
  var entityTypeName = 'CommunityRequest';
  var _b = __read(React.useState(false), 2),
    isSubmitting = _b[0],
    setIsSubmitting = _b[1];
  var _c = __read(React.useState(false), 2),
    isDeleting = _c[0],
    setIsDeleting = _c[1];
  var _d = __read(React.useState(false), 2),
    showInputModal = _d[0],
    setShowInputModal = _d[1];
  var _e = __read(React.useState(null), 2),
    editingRequest = _e[0],
    setEditingRequest = _e[1];
  var _f = __read(React.useState(null), 2),
    selectedDropdownItem = _f[0],
    setSelectedDropdownItem = _f[1];
  var createMutation = useEntityMutation({
    entityTypeName: entityTypeName,
    type: 'Create',
    fields: COMMUNITY_REQUEST_FIELDS
  });
  var updateMutation = useEntityMutation({
    entityTypeName: entityTypeName,
    type: 'Update',
    fields: COMMUNITY_REQUEST_FIELDS
  });
  var handleSubmitRequest = function (_a) {
    var id = _a.id;
    return function (_a) {
      return __awaiter(void 0, [_a], void 0, function (_b) {
        var inputData, mutationHook, variables, isEdit, err_1;
        var value = _b.value;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              inputData = __assign({
                title: value === null || value === void 0 ? void 0 : value.title,
                description: value === null || value === void 0 ? void 0 : value.description
              }, (value === null || value === void 0 ? void 0 : value.typeId) && {
                types: [value.typeId]
              });
              mutationHook = id ? updateMutation : createMutation;
              variables = id ? {
                id: id,
                input: inputData
              } : {
                input: inputData
              };
              isEdit = !!id;
              setIsSubmitting(true);
              _c.label = 1;
            case 1:
              _c.trys.push([1, 3, 4, 5]);
              return [4 /*yield*/, mutationHook.submit({
                variables: variables
              })];
            case 2:
              _c.sent();
              onSuccessSubmit(isEdit);
              refetchRequests();
              return [3 /*break*/, 5];
            case 3:
              err_1 = _c.sent();
              console.error("Error ".concat(id ? 'updating' : 'creating', " request:"), err_1);
              return [3 /*break*/, 5];
            case 4:
              setIsSubmitting(false);
              return [7 /*endfinally*/];
            case 5:
              return [2 /*return*/];
          }
        });
      });
    };
  };
  return {
    handleSubmitRequest: handleSubmitRequest,
    setIsDeleting: setIsDeleting,
    setShowInputModal: setShowInputModal,
    setIsSubmitting: setIsSubmitting,
    setEditingRequest: setEditingRequest,
    setSelectedDropdownItem: setSelectedDropdownItem,
    editingRequest: editingRequest,
    selectedDropdownItem: selectedDropdownItem,
    isSubmitting: isSubmitting,
    isDeleting: isDeleting,
    showInputModal: showInputModal
  };
};